<template>
  <div class="news">
    <div class="news-section" v-loading="loading">
      <div class="news-section-content">
        <div class="content-nav-item">
          <div
            class="item-list"
            v-for="(item, index) in paginatedNewsList"
            :key="index"
          >
            <router-link
              class="text-decoration"
              :to="{ name: 'classdetails', params: { id: item.id } }"
            >
              <div
                class="item-img" 
              >
              <img :src="item.img" width="300px"/>
            </div>
            
            <p  style="margin-top: 30px;color: black;text-align: center; padding: 10px">{{ item.title }}</p>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- Element UI 分页 -->
   <!-- 使用 Element UI 的分页组件 -->
   <el-pagination
      :current-page="currentPage"
      :page-size="itemsPerPage"
      :total="newsList.length"
      @current-change="handlePageChange"
      layout="prev, pager, next"
      class="pagination"
      background
    ></el-pagination>
  </div>
</template>

<script>
export default {
  name: "PublicClass",
  components: {
  
  },
  data() {
    return {
      loading: true,
      newsList: [],
      newstype: 3,  //type类型(1通知公告，2政策法规,3公益课堂)
      currentPage: 1,
      itemsPerPage: 6, // 每页显示3条数据
      totalItems: 0, // 总条目数
    };
  },
  computed: {
    // 计算分页后的数据
    paginatedNewsList() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      return this.newsList.slice(startIndex, endIndex);
    },
    // 计算总页数
    totalPages() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
  },
  methods: {
    loadData() {
      this.loading = true;
      this.$http
        .get(`/api/website/resource/webGetList?type=${this.newstype}&num=10`)
        .then((response) => {
          window.console.log(response);
          this.newsList = response.data.data;
          this.totalItems = response.data.data.length; // 设置总条目数
          this.loading = false;
        })
        .catch(function (error) {
          window.console.log(error);
        });
    },
    // 页码切换时的处理方法
    handlePageChange(page) {
      this.currentPage = page;
    },
  },
  mounted() {
    this.loadData();
  },
  watch: {
    newstype(type) {
      window.console.log(type);
      this.loadData();
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.news {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;

  &-section {
    width: 100%;

    &-content {
      width: 1240px;
      margin: 0 auto;
      background-color: #fff;

      .content-nav {
        width: 400px;
        height: 55px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        position: relative;
        bottom: 30px;
        border: 1px solid red;

        &-btn {
          width: 50%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #e4e4e4;
          transition: all 0.2s;
        }

        .content-nav-active {
          background-color: red;
          color: #fff;
        }
      }

      .content-nav-item {
        width: 1070px;
        margin: 0 auto;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;

        .item-list {
          width: 340px;
          height: 300px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin: 25px 5px;
          border-radius: 5px;
          background-color: whitesmoke;

          &:hover {
            border: 1px solid #fff;
            box-shadow: 0 0 5px 2px #bfd3e0;
          }
          .item-img {
            width: 300px;
            // height: 180px;
            background-color: #cecece;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            background-origin: content-box;
          }

          &-title {
            width: 300px;
            height: 50px;
            color: #15669e;
            font-size: 18px;
            padding: 0 10px;
            margin: 20px 0;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
  .text-decoration {
    text-decoration: none;
  }
}

/* Custom styles for pagination */
.pagination {
  margin-top: 30px;
  margin-bottom: 30px;
  text-align: center;
  height: 50px;
}
::v-deep .el-pagination .el-pager li {
  font-size: 18px !important; /* Increase the size of page numbers */
  padding: 10px !important;
  line-height: 8px !important;
}
</style>